import { Product } from '../../../types/product';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { productTheadData } from '../../../data/admin-data';

interface ProductTBodyProps {
    data: Product[];
    isLoading: boolean
    isError: boolean
    errorMessage: string;
    isEmpty: boolean
    handleUpdateProduct: (product: Product) => void;
}

export default function ProductTBody({ handleUpdateProduct, data, isLoading, isEmpty, errorMessage, isError }: ProductTBodyProps) {

    return (
        <tbody className='w-full'>
            {isLoading ? (
                <tr>
                    <td colSpan={productTheadData.length}  className='h-auto text-center'> 
                        <div className="flex space-x-1 justify-center items-center w-full h-full">
                            <Loading message="Loading product..." />
                        </div>
                    </td>
                </tr>
            ) : isError ? (
                <tr>
                    <td colSpan={productTheadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <ErrorMessage message={errorMessage} textStyle={``}/>
                        </div>
                    </td>
                </tr>
            ) : isEmpty ? (
                <tr>
                    <td colSpan={productTheadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <p className='text-gray-500 text-xs'>No result found.</p>
                        </div>
                    </td>
                </tr>
            ) : (
                data.map((data, index) => {
                    const category = data.categoryInfo?.categoryName ?? ''
                    const addons = data.addons ?? [];
                    const isAvailable = data.isAvailable ? 'Yes' : 'No'
                    return (
                        <tr 
                            key={index} 
                            className={`hover:bg-gray-100 text-xs cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                        >
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-medium">
                                    {`${data.productName}`}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {category}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <span
                                    className={`inline-flex rounded px-2 py-0.5 text-xs font-normal ${
                                        data.isAvailable
                                            ? "bg-green-100 text-green-700"
                                            : "bg-red-100 text-red-700"
                                    }`}
                                >
                                    {isAvailable}
                                </span>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {data.sizeInfo.size}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {data.typeInfo?.typeName ?? ''}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {data.price}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="col-span-3 mt-1 flex flex-col text-[11px] text-gray-600">
                                    {addons.map((add) => (
                                        <div className='font-normal' key={add.addonID}>{add.addonName}</div>
                                    ))}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-semibold">
                                    <button
                                        onClick={() => handleUpdateProduct(data)}
                                        className="text-cbColor text-xs px-4 py-1.5 rounded transition"
                                    >
                                        Edit
                                    </button>
                                </div>
                            </th>
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}
